module.exports = __webpack_public_path__ + "img/hr-pipe-straight-horizontal-single.000494f0.png";